/**
 * The root fallback. Documented exception to the no-hardcoded-copy rule: this screen must work
 * when the i18n runtime has itself failed, which is one of the reasons it exists.
 *
 * A full document reload, not a remount. The failure may be a stale chunk after a deploy, and a
 * remount would re-request the same missing hash.
 */
export function RootFallback() {
  return (
    <main className="bg-background text-text grid min-h-dvh place-items-center px-4">
      <div className="mx-auto max-w-md text-center">
        <h1 className="text-xl font-semibold">This page ran into a problem</h1>
        <p className="text-text-muted mt-2 text-sm">
          Reload to continue. Your payment has not been affected.
        </p>
        <button
          type="button"
          className="bg-primary text-on-primary mt-6 inline-flex min-h-11 items-center justify-center rounded-lg px-4 font-medium"
          onClick={() => {
            window.location.reload();
          }}
        >
          Reload the page
        </button>
      </div>
    </main>
  );
}
